import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import "./Banner.css";
import banner1 from "../../../images/banner1.jpg";
import banner2 from "../../../images/banner2.jpg";
import banner3 from "../../../images/banner3.jpg";

const Banner = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <div>
      <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img
            className="d-block w-100 banner1"
            src={banner1}
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Thank you for choosing us!</h3>
            <p>We will provide the best Camping Gears</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100  banner2"
            src={banner2}
            alt="Second slide"
          />

          <Carousel.Caption>
            <h3>Thank you for choosing us!</h3>
            <p>We will provide the best Camping Gears</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100  banner3"
            src={banner3}
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>Thank you for choosing us!</h3>
            <p>We will provide the best Camping Gears</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      );
    </div>
  );
};

export default Banner;
